import { omit } from "lodash";
import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Form, Icon, Input, Popup } from "semantic-ui-react";

import FormikAPIErrorMessage from "./FormikAPIErrorMessage.jsx";

import { getErrorStateFromProps } from "../formUtils.js";

class FormikSemanticInput extends PureComponent {
  static propTypes = {
    field: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    apiErrors: PropTypes.object,
    label: PropTypes.string,
    help: PropTypes.string,
    placeholder: PropTypes.string
  };

  renderHelpPopup() {
    const { help } = this.props;

    if (!help) return null;

    return (
      <Popup
        trigger={
          <Icon name="help circle" color="orange" className="float-right" />
        }
        content={help}
        position="top right"
        offset={[11, 0]}
        wide
      />
    );
  }

  render() {
    const {
      field: { name, value },
      form: { setFieldValue, setFieldTouched },
      readOnly,
      disabled,
      label,
      type,
      required,
      apiErrors
    } = this.props;

    // set semantic-ui field error state
    const isError = getErrorStateFromProps(this.props);

    // needed to adjust field margin-bottom if error is shown
    const className = isError ? "errored" : null;

    const inputProps = {
      ...omit(this.props, "field", "form", "apiErrors", "label"),
      ...this.props.field,
      id: name,
      type: type ? type : "text",
      error: isError
    };

    const isRequired = readOnly || disabled ? false : required;

    if (!readOnly) {
      return (
        <Form.Field error={isError} required={isRequired} className={className}>
          {this.renderHelpPopup()}
          {label && <label htmlFor={name}>{label || null}</label>}
          <Input
            {...inputProps}
            onChange={(e, { name, value: changeValue }) => {
              setFieldValue("ignoreChangeInSideEffect", false);
              setFieldValue(name, changeValue);
            }}
            onBlur={evt => {
              setFieldTouched(name, true);
              setFieldValue("ignoreChangeInSideEffect", false);
            }}
          />
          <FormikAPIErrorMessage name={name} apiErrors={apiErrors} />
        </Form.Field>
      );
    }

    return (
      <Form.Field className={className}>
        {this.renderHelpPopup()}
        {label && <label>{label || null}</label>}
        <p>{value || "-"}</p>
      </Form.Field>
    );
  }
}

export default FormikSemanticInput;
